import type { Catalog } from "../../en";

/** Filipino: Leads & inquiries (mirrors en/engage/leads.ts). */
export const leads: Catalog["engage"]["leads"] = {
  title: "Mga lead at inquiry",
  subtitle: "Mga taong nagbigay ng contact details sa assistant. Mag-follow up bago sila pumunta sa iba.",
  leadFormFields: "Mga field ng lead form",
  exportCsv: "I-export ang CSV",
  exported: "Na-export ang mga lead · {{file}}",
  exportNoPermission: "Kailangan ng export permission para ma-export ang mga lead.",
  syncToCrm: "I-sync sa CRM",
  crm: {
    google_sheets: "Google Sheets",
    hubspot: "HubSpot",
    zoho: "Zoho CRM",
    connected: "Nakakonekta · auto-sync bawat 15 min",
    notConnected: "Hindi nakakonekta",
    other: "Webhook at iba pang integration",
    synced_one: "Na-sync ang {{count}} lead sa {{provider}}",
    synced_other: "Na-sync ang {{count}} lead sa {{provider}}",
    failed: "Hindi pa nakakonekta ang {{provider}}. Ikonekta muna ito sa mga integration.",
    reconnectNeeded: "Kailangang ikonekta ulit",
    needsReconnect: "Kailangang ikonekta ulit ang {{provider}}",
    openIntegrations: "Buksan ang Integrations",
    partial: "{{synced}} ang na-sync, {{failed}} ang hindi tinanggap ng {{provider}} (i-edit ang mga ito at mag-sync ulit)",
  },
  editStages: "Mga stage ng pipeline",
  stats: {
    thisWeek: "Mga lead ngayong linggo",
    deltaUp: "+{{count}} kumpara noong nakaraang linggo",
    deltaDown: "{{count}} kumpara noong nakaraang linggo",
    deltaFlat: "Kapareho noong nakaraang linggo",
    topChannel: "Mula sa {{channel}}",
    noChannel: "Ayon sa channel",
    channelSplit: "{{channels}}",
    noLeadsYet: "Wala pang lead",
    wonRate: "Lead → won",
    wonHint: "Mga lead na umabot sa won na stage",
    firstFollowUp: "Avg na unang follow-up",
    hours: "{{value}} h",
    waiting_one: "{{count}} lead na naghihintay > 24 h",
    waiting_other: "{{count}} lead na naghihintay > 24 h",
    noneWaiting: "Walang lead na naghihintay > 24 h",
  },
  view: {
    label: "View",
    table: "Table",
    board: "Board",
    bookings: "Bookings",
  },
  stageFilter: "I-filter ayon sa stage",
  all: "Lahat",
  search: "Hanapin ang pangalan, email, interes…",
  interest: "Interes",
  allInterests: "Lahat ng interes",
  columns: {
    name: "Pangalan · email",
    mobile: "Telepono",
    interest: "Interes",
    source: "Pinagmulan",
    conversation: "Usapan",
    owner: "Naka-assign",
    stage: "Stage",
    created: "Ginawa",
  },
  unassigned: "Walang naka-assign",
  stageLabel: "Stage ni {{name}}",
  movedTo: "Inilipat si {{name}} sa {{stage}}",
  idle: "Idle > 24 h",
  idleHint: "Walang follow-up nang higit 24 oras",
  openLead: "Buksan si {{name}}",
  showing: "Ipinapakita ang {{shown}} sa {{total}}",
  emptyTitle: "Walang lead sa stage na ito",
  emptyBody: "Lalabas dito ang mga contact details na makukuha ng assistant.",
  emptyFiltered: "Subukan ang ibang stage o i-clear ang search.",
  clearFilters: "I-clear ang mga filter",
  loadError: "Hindi ma-load ang mga lead.",
  footnote:
    "Kinokolekta ang lead data nang may pahintulot ayon sa inyong privacy notice. Nakikita ng mga bisita ang privacy notice bago isumite ang lead form. Bahagyang nakatago ang mga phone number para sa staff na walang export permission.",
  board: {
    label: "Pipeline board",
    column: "{{stage}} · {{count}} lead",
    empty: "Walang lead",
    moveTo: "Ilipat sa…",
    moveMenu: "Ilipat si {{name}}",
    dragHint: "I-drag ang card sa ibang stage, o i-focus ang card at pindutin ang Alt + ← / → para ilipat.",
    moved: "Inilipat si {{name}} sa {{stage}}",
    more: "+{{count}} pa sa stage na ito",
  },
  sheet: {
    via: "{{interest}} · sa {{channel}}",
    call: "Tumawag",
    sendEmail: "Mag-send ng email",
    openConversation: "Buksan ang usapan",
    mobile: "Telepono",
    email: "Email",
    learner: "Detalye",
    interest: "Interes",
    preferredContact: "Gustong paraan ng contact",
    consent: "Pahintulot",
    noConsent: "Hindi naitala",
    created: "Nakuha",
    owner: "Naka-assign kay",
    stage: "Stage",
    summaryTitle: "Buod ng usapan · gawa ng AI",
    noSummary: "Wala pang buod. Gumawa mula sa usapan.",
    intent: "Malamang na intensyon: {{intent}}.",
    nextStep: "Mungkahing susunod na hakbang: {{step}}",
    regenerate: "Gawing muli",
    summaryFailed: "Hindi magawa ang buod sa ngayon.",
    activity: "Aktibidad",
    notes: "Mga tala",
    notePlaceholder: "Magdagdag ng tala para sa team…",
    noteLabel: "Bagong tala",
    addNote: "Idagdag",
    noteRequired: "Sumulat muna ng tala",
    noteAdded: "Naidagdag ang tala",
    noNotes: "Wala pang tala.",
    stageUpdated: "Na-update ang stage sa {{stage}}",
    assigned: "Na-assign kay {{name}}",
    unassignedToast: "Tinanggal ang assignment ng lead",
    loadError: "Hindi ma-load ang lead na ito.",
    notFound: "Wala na ang lead na iyon.",
    customFields: "Mga sagot sa lead form",
    readOnly: "Makikita mo ang lead na ito pero hindi mo ito mababago.",
  },
  activityType: {
    created: "Nakuha ang lead",
    createdVia: "Nakuha ang lead sa {{channel}}",
    stage_changed: "Stage → {{to}}",
    assigned: "Na-assign kay {{name}}",
    unassigned: "Walang naka-assign",
    note: "Naidagdag ang tala",
    call: "Naitala ang tawag",
    email: "Naitala ang email",
    sms: "Naitala ang SMS",
    summary: "Ginawa ang AI summary",
    synced: "Na-sync sa CRM",
    other: "Aktibidad",
    by: "ni {{name}}",
    system: "System",
  },
  stagesDialog: {
    title: "Mga stage ng pipeline",
    description: "Palitan ang pangalan, ayusin ang pagkakasunod, at markahan ang mga stage. Panatilihin ang kahit isang won at isang lost na stage.",
    name: "Pangalan ng stage {{n}}",
    won: "Won",
    lost: "Lost",
    outcome: "Resulta para sa {{name}}",
    open: "Bukas",
    moveUp: "Itaas ang {{name}}",
    moveDown: "Ibaba ang {{name}}",
    remove: "Alisin ang {{name}}",
    add: "Magdagdag ng stage",
    newStage: "Bagong stage",
    leads_one: "{{count}} lead",
    leads_other: "{{count}} lead",
    reassign: "Ilipat ang mga lead nito sa",
    reassignLabel: "Ilipat ang mga lead mula sa {{name}} papunta sa",
    reassignRequired: "Piliin kung saan mapupunta ang mga lead ng “{{name}}”.",
    needWon: "Panatilihin ang kahit isang won na stage.",
    needLost: "Panatilihin ang kahit isang lost na stage.",
    nameRequired: "Kailangan ng pangalan ang bawat stage.",
    duplicate: "Dapat magkakaiba ang mga pangalan ng stage.",
    tooFew: "Panatilihin ang kahit {{count}} stage.",
    tooMany: "Hanggang {{count}} stage lang.",
    save: "I-save ang mga stage",
    saved: "Na-save ang mga stage ng pipeline",
    conflict: "May lead pa ang inalis na stage. Piliin kung saan sila ililipat.",
    noPermission: "Kailangan ng workspace management permission para ma-edit ang mga stage.",
  },
};
